import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import SignUp from "./pages/SignUp";
import LogIn from "./pages/LogIn";
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import About from './pages/About';
import Contact from './pages/Contact';
import Diagnostics from './pages/Diagnostics';
import CPC from './pages/CPC';
import LearningHub from './pages/LearningHub';
import Transactions from './pages/Transactions';
import Videoplayer from './pages/student/videoplayer'

import BiopsyCaseList from './pages/BiopsyCaseList';
import BiopsyCaseForm from './pages/BiopsyCaseForm';
import BiopsyCaseView from './pages/BiopsyCaseView';
import BiopsyListDispatcher from './pages/biopsy/dispatchers/BiopsyListDispatcher';
import BiopsyViewDispatcher from './pages/biopsy/dispatchers/BiopsyViewDispatcher';
import BiopsyFormDispatcher from './pages/biopsy/dispatchers/BiopsyFormDispatcher';
import AdminBiopsyPathologyList from './pages/biopsy/admin/AdminBiopsyPathologyList';
import AdminBiopsyDoctorList from './pages/biopsy/admin/AdminBiopsyDoctorList';


import ManageModule from './pages/manageModule';
import EditModule from './pages/editModule';
import ViewModule from './pages/viewModule';
import AdminQuiz from './pages/adminquiz';
import EditAdminQuiz from './pages/editAdminquiz';
import EditModulecase from "./pages/EditModulecase";
// import ViewAdminquiz from './pages/viewAdminquiz';


import ManageCase from './pages/createCase';
import EditLearningcase from './pages/editLearningcase';
import ViewLearningcase from './pages/viewLearningcase';
import CasesImport from './pages/CasesImport';
import CasesCreate from './pages/CasesCreate';
import BulkImageUpload from './pages/BulkImageUpload';
import SharedDziView from './pages/SharedDziView';

// import Additionaltests from './pages/Additionaltests';
import Usermanagement from './pages/userManage';
import EditUser from './pages/editUser';
import ViewUser from './pages/viewUser';
import ViewFellows from './pages/viewFellows';
import EditFellows from './pages/editFellows';

import ManageTest from './pages/manageTest';
import EditTest from './pages/editTest';
import ViewTest from './pages/viewTest';

import ManageLectureLibrary from './pages/manageLecturelibrary';
import EditLectureLibrary from './pages/editLecturelibrary';
import ViewLectureLibrary from './pages/viewLecturelibrary';

import BiopsyTypeList from './pages/BiopsyTypeList';
import BiopsyTypeForm from './pages/BiopsyTypeForm';
import BiopsyTypeView from './pages/BiopsyTypeView';

import Lookups from './pages/Lookups';
import Modules from './pages/Modules';
import Subscription from './pages/Subscription';
import LearningHub1 from './pages/LearningHub1';
import Modulesection from './pages/Modulesection';
import Library from './pages/Library';
import CPCsection from './pages/CPCsection';
import MyAccount from './pages/MyAccount';
import CreatePassword from './pages/createPassword';
import QuizHome from "./pages/home/student-cpc";
import CPCInfo from './pages/quiz/cpcinfo';
import CPCResInfo from './pages/quizzes/quiz/completedCPCRes';



// import NotFound from "./pages/NotFound";
import AdminSignIn from "./pages/AdminSignIn";
import Thankyou from "./pages/thankyou/thankyou";
import QuizDetails from "./pages/quizDetails";
import Profile from "./pages/profile";

import Quizzes from "./pages/quizzes/quiz/index";


import ManageQuiz from './pages/manageQuiz';
import EditQuiz from './pages/editQuiz';
import ViewQuiz from './pages/editQuiz';



import AddQuestion from './pages/quizzes/addquestion'
import ClinicanHome from "./pages/clinicians/clinicianshome";
import Compeletedquiz from './pages/quizzes/quiz/completedquiz';
import Cpcmanagement from './pages/quizzes/quiz/cpcmanagement';
import Subcribe from './pages/quizzes/quiz/';
import BillingPage from './pages/quizzes/quiz/billingpage';
import Fellowship from './pages/student/fellowship';

import Upcomingquiz from './pages/quizzes/quiz/upcomingquiz';

import QuizPage from "./pages/quiz/quiz";
import GeneratePassword from './pages/pwdGenerate';
import LibraryVideos from './pages/libraryvideos';


import CPCStudent from './pages/student/CPCStudent';
import LectureLibrary from './pages/student/LectureLibrary';
import LectureModule from './pages/student/LectureModule';
import Answers from './pages/answers';
import CPCResult from './pages/CPCResult';
import CpcRegistration from './pages/cpcRegistration';
import LearningModule from './pages/student/LearningModule';
import Instructions from './components/instructions';
import ModuleLibrary from './pages/ModuleLibrary';
import ModuleQuiz from './pages/ModuleQuiz';
import ModuleResult from './pages/ModuleResult';
import SubscriptionPlans from './pages/SubscriptionPlans';
import TransactionList from './pages/TransactionList';
import TransactionData from './pages/TransactionData';

import FellowshipList from './pages/Fellowship';
import Result from './pages/result/result';
import RegisteredUsers from './pages/registered usres/RegisteredUsers';
import History from './pages/History';
import Fellows from './pages/pathologist/Fellows';
import Fellow from './pages/pathologist/editFellow';
import AddModule from './pages/AddModule';
import Feedbacks from './pages/feedbacks';
import ViewHistory from './pages/ViewHistory';
import CaseFeedback from './pages/casefeedback';
import SubmittedModules from './pages/pathologist/SubmittedModules';
import AddSummary from './pages/pathologist/AddSummary';
import EditFellowshipModule from './pages/EditFellowshipModule';
import GeneralInstructions from './components/General-instructions';
import EmailManager from './pages/emailmanager/emailManager';
import EditEmailTemplate from './pages/emailmanager/editEmailTemplate';
import ViewEmailTemplate from './pages/emailmanager/viewEmailTemplate';
import ShareHistory from './pages/sharehistory/ShareHistory';
import ViewShareHistory from './pages/sharehistory/ViewShareHistory';
import EditShareHistory from './pages/sharehistory/EditShareHistory';

function App() {




  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<LogIn />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/diagnostics" element={<Diagnostics />} />
        <Route path="/Pathologic-Correlation" element={<CPC />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/upcomingquiz" element={<Upcomingquiz />} />
        {/* <Route path="/myaccount" element={<MyAccount />} /> */}
        <Route path="/createpassword" element={<CreatePassword />} />
        <Route path="/clinicianhome" element={<ClinicanHome />} />
        {/* 
            <Route path="/additionaltests" element={<Additionaltests />} /> */}
        <Route path="/users" element={<Usermanagement />} />
        <Route path="/adduser" element={<EditUser />} />
        <Route path="/edituser/:id" element={<EditUser />} />
        <Route path="/viewuser/:id" element={<ViewUser />} />
        <Route path="/viewfellows/:id" element={<ViewFellows />} />
        <Route path="/editfellows/:id" element={<EditFellows />} />

        <Route path="/tests" element={<ManageTest />} />
        <Route path="/addtest" element={<EditTest />} />
        <Route path="/edittest/:id" element={<EditTest />} />
        <Route path="/viewtest/:id" element={<ViewTest />} />

        <Route path="/videoplayer/:id" element={<Videoplayer />} />
        <Route path="/billingpage/:planId" element={<BillingPage />} />
        <Route path="/billingpage" element={<BillingPage />} />

        <Route path="/editfellow/:id" element={<Fellow />} />
        <Route path="/lecturelibrary" element={<ManageLectureLibrary />} />
        <Route path="/addlecturelibrary" element={<EditLectureLibrary />} />
        <Route path="/editlecturelibrary/:id" element={<EditLectureLibrary />} />
        <Route path="/viewlecturelibrary/:id" element={<ViewLectureLibrary />} />
        <Route path="/subcribe" element={<Subcribe />} />

        <Route path="/biopsy/types" element={<BiopsyTypeList />} />
        <Route path="/biopsy/types/new" element={<BiopsyTypeForm />} />
        <Route path="/biopsy/types/:id/edit" element={<BiopsyTypeForm />} />
        <Route path="/biopsy/types/:id" element={<BiopsyTypeView />} />

        <Route path="/biopsy/cases" element={<BiopsyListDispatcher />} />
        <Route path="/biopsy/cases/new" element={<BiopsyFormDispatcher />} />
        <Route path="/biopsy/admin/pathologist" element={<AdminBiopsyPathologyList />} />
        <Route path="/biopsy/admin/doctor" element={<AdminBiopsyDoctorList />} />
        <Route path="/biopsy/cases/:id/edit" element={<BiopsyFormDispatcher />} />
        <Route path="/biopsy/cases/:id" element={<BiopsyViewDispatcher />} />

        <Route path="/shared-view/:shareId" element={<SharedDziView />} />
        <Route path="/cases" element={<ManageCase />} />
        <Route path="/sharedlinks" element={<ShareHistory />} />
        <Route path="/sharedlinks/view/:shareid" element={<ViewShareHistory />} />
        <Route path="/sharedlinks/edit/:shareid" element={<EditShareHistory />} />
        <Route path="/casesupload" element={<CasesImport />} />
        <Route path="/casescreate" element={<CasesCreate />} />
        <Route path="/bulkimageupload" element={<BulkImageUpload />} />
        <Route path="/addcase" element={<EditLearningcase />} />
        <Route path="/editcase/:id" element={<EditLearningcase />} />

        <Route path="/editmodulecase/:id/:moduleid" element={<EditModulecase />} />
        {/* <Route path="/editmodulecase/:id" element={<ViewLearningcase />} /> */}

        <Route path="/viewcase/:id" element={<ViewLearningcase />} />

        <Route path="/lookups" element={<Lookups />} />
        {/* <Route path="/modules" element={<Modules />} /> */}
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/learning" element={<LearningHub />} />
        <Route path="/modulesection" element={<Modulesection />} />
        <Route path="/library" element={<Library />} />
        <Route path="/CPCsection" element={<CPCsection />} />
        <Route path={`/cpc`} element={<QuizHome />} />
        <Route path={`/quiz`} element={<QuizPage />} />
        <Route path={`/quiz/:id`} element={<QuizPage />} />

        <Route path={`/thankyou`} element={<Thankyou />} />
        {/* <Route path={`/register`} exact component={Register} />*/}


        <Route path={`/quizdetails`} element={<QuizDetails />} />
        <Route path={`/cpcregistration`} element={<CpcRegistration />} />
        {/* <Route path={'/admin'} element={<AdminSignIn />}  />
           <Route path={`/login`} element={<AdminSignIn />} /> */}
        <Route path={`/profile`} element={<Profile />} />
        <Route path={`/answers`} element={<Answers />} />
        <Route path={`/dashboard`} element={<Quizzes />} />

        <Route path={`/admin-quiz`} element={<Quizzes />} />

        <Route path={`/quizzes`} element={<ManageQuiz />} />
        <Route path={`/addquiz`} element={<EditQuiz />} />
        <Route path={`/editquiz/:id`} element={<EditQuiz />} />
        <Route path={`/viewquiz/:id`} element={<EditQuiz />} />

        <Route path="/feedbacks" element={<Feedbacks />} />
        <Route path={`/cpcmanagement`} element={<Cpcmanagement />} />
        <Route path={`/cpcmanagement/:id`} element={<Cpcmanagement />} />

        <Route path={'/completedquiz'} element={<Compeletedquiz />} />


        <Route path={`/addquestion/:id`} element={<AddQuestion />} />
        <Route path="/generatepwd" element={<GeneratePassword />} />
        <Route path="/libraryvideos" element={<LibraryVideos />} />


        <Route path="/cpc-student" element={<CPCStudent />} />
        <Route path="/lecture-module" element={<LectureModule />} />
        <Route path="/lecture-library" element={<LectureLibrary />} />


        <Route path='fellowship' element={<Fellowship />} />
        <Route path='cpc-result/:id' element={<CPCResult />} />

        <Route path="/cpcinfo/:id" element={<CPCInfo />} />
        <Route path='/instructions/:id' element={<Instructions />} />
        <Route path="/timed-instructions/:id" element={<GeneralInstructions type="Timed Module" />} />
        <Route path="/moduleinstructions/:id" element={<GeneralInstructions type="Self" />} />
        <Route path="/mcqinstructions/:id" element={<GeneralInstructions type="MCQ" />} />

        <Route path="/cpccompletedinfo/:id" element={<CPCResInfo />} />

        <Route path="/modules" element={<ManageModule />} />
        <Route path="/addmodule" element={<AddModule />} />
        <Route path="/editmodule/:id" element={<EditModule />} />
        <Route path="/viewmodule/:id" element={<ViewModule />} />


        <Route path="/moduleslibrary" element={<ModuleLibrary type="all" />} />
        <Route path="/usermoduleslibrary" element={<ModuleLibrary type="all" />} />
        <Route path="/mcqmoduleslibrary" element={<ModuleLibrary type="all" moduleType="mcqmodule" />} />
        <Route path="/timedmodule" element={<ModuleLibrary type="all" moduleType="timedmodule" />} />
        <Route path="/timedmodule/:id" element={<ModuleQuiz type="all" moduleType="Timed Module" />} />

        <Route path="/fellowshipmodules" element={<ModuleLibrary type="all" />} />
        <Route path="/fellowshipmodules/:id" element={<ModuleQuiz type="all" moduleType="FELLOWSHIP" />} />
        <Route path="/editfellowshipmodule/:id" element={<EditFellowshipModule />} />

        <Route path="/moduleslibrary/:id" element={<ModuleQuiz type="all" moduleType="SELF" />} />
        <Route path="/usermoduleslibrary/:id" element={<ModuleQuiz type="user" moduleType="SELF" />} />
        <Route path="/mcqmoduleslibrary/:id" element={<ModuleQuiz type="user" moduleType="MCQ" />} />
        <Route path="/submitted-modules/:id" element={<SubmittedModules />} />
        {/* <Route path="/add-summary/:id" element={<ModuleQuiz type="all" moduleType="CASE-SUMMARY" />} /> */}
        <Route path="/add-summary/:id" element={<AddSummary moduleType="CASE-SUMMARY" />} />

        <Route path="/modulesresult/:id" element={<ModuleResult />} />



        <Route path="subscriptionplans" element={<SubscriptionPlans />} />
        <Route path="transctions" element={<TransactionList />} />
        <Route path="transactiondata" element={<TransactionData />} />

        <Route path="fellowshiplist" element={<FellowshipList />} />
        <Route path="registeredusers" element={<RegisteredUsers />} />
        <Route path="fellows" element={<Fellows />} />
        <Route path="/history/:id" element={<History />} />
        <Route path="/viewhistory/:id" element={<ViewHistory />} />
        <Route path="/usermoduleslibrary/:id" element={<ModuleQuiz type="user" />} />
        <Route path="/casefeedback/:id/:caseid" element={<CaseFeedback />} />

          <Route path="/emailhistory" element={<EmailManager />} />
           <Route path="/sendEmail" element={<EditEmailTemplate />} />
           <Route path="/viewemailtemplate/:logid" element={<ViewEmailTemplate />} />

        <Route path="/result/:id" element={<Result />} />
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </Router>
  );
}

export default App;
